
import { Component, Vue } from "vue-property-decorator";
import {
  dispatchSubmitSignUp,
  dispatchСheckPromocode,
  dispatchGetUserPromocodes,
  dispatchActionCreateUserPromocode,
} from "@/store/main/actions";
import { IProductSentencesResponse } from "@/interfaces";
import { getDocLink } from "@/i18n/locales";
import { SERVICE_TYPES } from "@/constants";

@Component({
  methods: { getDocLink },
  components: {},
})
export default class SignUp extends Vue {
  public email: string = "";
  public is_successfull: boolean = false;
  public password: string = "";
  public promocode: string = "";
  public referral: any = null;
  public formError: boolean = false;
  public emailError: boolean = false;
  public sentencesResponse: IProductSentencesResponse = {
    products: [],
    promocode: null,
  };
  public loadingState: any = {
    submit: false,
    promo: false,
  };

  public cookieCheckbox: boolean = true;
  public agreementCheckbox: boolean = true;
  public policyCheckbox: boolean = true;
  public ofertaCheckbox: boolean = true;
  public partnershipCheckbox: boolean = true;
public taxObligationCheckbox: boolean = true;
  public passwordError: boolean = false;

  public isLoadingCreate: boolean = false;

  public serviceTypes = SERVICE_TYPES;
  

  public mounted() {
    if (this.$router.currentRoute.params.promocode) {
      this.promocode = this.$router.currentRoute.params.promocode;
      this.handleUpdatePromocode();
    }
  }

  public validateData() {
  // сброс ошибок
  this.formError = false;
  this.passwordError = false;
  this.emailError = false;

  if (!this.cookieCheckbox || !this.agreementCheckbox || 
      !this.policyCheckbox || !this.ofertaCheckbox ||
      !this.partnershipCheckbox || !this.taxObligationCheckbox) {
    this.formError = true;
    this.$toast.error(this.$t("You need to agree with all conditions").toString());
    return false;
  }

  if (!this.password) {
    this.formError = true;
    this.passwordError = true;
    this.$toast.error(this.$t("The password field is required").toString());
    return false;
  }

  if (!this.isPasswordValid) {
    this.passwordError = true;
    this.formError = true;
    this.$toast.error(this.$t("Password contains invalid characters").toString());
    return false;
  }

  if (!this.email || !/(.+)@(.+){1,}\.(.+){2,}/.test(this.email) ) {
    this.formError = true;
    this.$toast.error(this.$t("Invalid email").toString());
    return false;
  }

  if(!this.referral){
     this.formError = true;
    this.$toast.error(this.$t("Promocode is required").toString());
    return false;
  }

  return true;
}

  public async handleSubmit() {
    if (await this.validateData()) {
  
      this.loadingState.submit = true;

      const response = await dispatchSubmitSignUp(this.$store, {
        email: this.email,
        password: this.password,
        referral: this.referral.id,
        language: navigator.language.slice(0, 2),
        timezone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });

      if (response.status === 200 || response.status === 201) {
        /** generate promocode 10% */
        // this.createPublicKey();
        for (const serviceType of this.serviceTypes) {
          const payload = {
            code: null,
            comment: null,
            service_type: serviceType,
          };
          await dispatchActionCreateUserPromocode(this.$store, payload);
        }

        this.is_successfull = true;
        this.$router.push('/dashboard');
      } else if (response.status === 400) {
        if (response.data.email) {
          // this.$toast.error(this.$t('Email is already exists').toString());
          this.emailError = true;
        } else {
          this.$toast.error(this.$t("Error").toString());
        }
      } else if (response.status === 504) {
        this.is_successfull = true;
      } else {
        this.$toast.error(this.$t("Error").toString());
      }
      this.loadingState.submit = false;
    }
  }

  public async handleUpdatePromocode() {
    if (!this.promocode) {
      this.referral = null;
      this.loadingState.promo = false;
      return;
    }
    this.referral = await dispatchСheckPromocode(this.$store, {
      referral: this.promocode,
    });
    this.loadingState.promo = false;
  }

  // generate public promocode on signup
  public async createPublicKey() {
    this.isLoadingCreate = true;
    try {
      const payload = {
        code: null,
        comment: null,
        service_type: null,
      };
      await dispatchActionCreateUserPromocode(this.$store, payload);
      await this.updateMyPromoCodes();
      // this.$toast.success(this.$t("Promo code activated successfully").toString());
    } catch (error) {
      this.$toast.error("Failed to create prmocodes, please try again later");
    } finally {
      this.isLoadingCreate = false;
    }
  }


  public async createAllPublicKey() {
    this.isLoadingCreate = true;
    
    try {
      for (const serviceType of this.serviceTypes) {
      const payload = {
        code: null,
        comment: null,
        service_type: serviceType,
      };
      await dispatchActionCreateUserPromocode(this.$store, payload);
    }
      // this.$toast.success(this.$t("Promo code activated successfully").toString());
    } catch (error) {
      this.$toast.error("Failed to create prmocodes, please try again later");
    } finally {
      await this.updateMyPromoCodes();
      this.isLoadingCreate = false;
      
    }
  }

  public async updateMyPromoCodes() {
    // console.log('update promo')
    await dispatchGetUserPromocodes(this.$store);
  }

  // geters
  get isPasswordValid(): boolean {
  const allowedChars = /^[a-zA-Z0-9!?@\u2116%&$#]+$/;
  return allowedChars.test(this.password);
}
}
